import { IEmailHoneyPotControllerReturn } from "./EmailHoneyPotController"

interface IProps {
  hpc: IEmailHoneyPotControllerReturn;
}

export const EmailHoneyPot: React.FC<IProps> = (props): JSX.Element => {

  return (
    <>
      <div
        className="hidden"
      >
        <div className="flex-row" >
          <label htmlFor="firstname">Firstname *</label>
          <input
            id="firstname"
            name="firstname"
            type="text"
          />
        </div>
        <div className="flex-row" >
          <label htmlFor="lastname">Lastname *</label>
          <input
            id="lastname"
            name="lastname"
            type="text"
          />
        </div>
        <div className="flex-row" >
          <label htmlFor="email">Email *</label>
          <input
            id="email"
            name="email"
            type="text"
          />
        </div>
      </div>
    </>
  )
}